import React, { useState } from "react";
import { Typography } from "@material-tailwind/react";
import Contact from "../pages/ContactDialog";
import { useUserSession } from "../../lib/session/UserSession";

export default function Footer({ className = "" }) {
  const [showContactUs, setShowContactUs] = useState(false);
  const { sessionStore } = useUserSession();
  const appMeta = {
    ...sessionStore.APP_META.APPLICATION,
  };

  return (
    <footer
      className={`pl-4 pr-4 z-10 w-full flex flex-row flex-wrap items-center justify-center gap-y-6 gap-x-12 py-2 text-center md:justify-between bg-gray-900 ${className}`}
    >
      <Typography color="white" className="font-normal text-left w-full md:w-auto md:text-center">
        {new Date().getFullYear()}&nbsp;&copy;&nbsp;{appMeta.COPYRIGHT_LABEL}
      </Typography>
      <ul className="flex flex-wrap items-center gap-y-2 gap-x-8">
        <li>
          <Typography
            as="a"
            href="/about"
            color="white"
            className="font-normal transition-colors hover:text-blue-500 focus:text-blue-500"
          >
            About Us
          </Typography>
        </li>
        <li>
          <Typography
            onClick={() => setShowContactUs(!showContactUs)}
            color="white"
            className="font-normal transition-colors hover:text-blue-500 focus:text-blue-500 rounded-2xl hover:cursor-pointer"
          >
            Contact Us
          </Typography>
          <Contact showContactUs={showContactUs} setShowContactUs={setShowContactUs} />
        </li>
      </ul>
    </footer>
  );
}
